import { request } from '@/_service/http-client';
import { IMultiLang } from '@/_types';

export const shipperTagApi = {
    getAll: async (params: { page: number; limit: number }) => {
        const response = await request.get<{ shipper_tags: { id: string, title: IMultiLang }[] }>('/v2/shipper-tag', { params });
        return response.data;
    }
}